module.exports = __webpack_public_path__ + "static/media/fyla3h.2d7a7866.md";